export default "__VITE_ASSET__17124ee5__"